function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import cn from 'classnames';
import { InputText } from '../InputText';
import { IInputTextProps } from '../InputText';
import { useUniqId } from '../../hooks/useUniqId';
import { useInputText } from '../../hooks/useInputText';
import { useResizeObserver } from '../../hooks/useResizeObserver';
require("./FieldText.css");
var styles = {
  "Root": "FieldText-module-Root_2bC",
  "HasFocus": "FieldText-module-HasFocus_3s2",
  "HasError": "FieldText-module-HasError_MY6",
  "IsDisabled": "FieldText-module-IsDisabled_DDm",
  "Label": "FieldText-module-Label_23j",
  "Error": "FieldText-module-Error_2Kk",
  "Counter": "FieldText-module-Counter_2BE",
  "Header": "FieldText-module-Header_MCU",
  "HasIndependentLabel": "FieldText-module-HasIndependentLabel_39P",
  "HasValue": "FieldText-module-HasValue_21E",
  "isMultiLine": "FieldText-module-isMultiLine_3Tl",
  "IsLabelStuck": "FieldText-module-IsLabelStuck_cXS",
  "HelperText": "FieldText-module-HelperText_13i",
  "mSize": "FieldText-module-mSize_2NO",
  "lSize": "FieldText-module-lSize_xjc"
};
/**
 * Компонент текстового ввода;
 * Поддерживает как однострочное поле (input), так и многострочное (textarea)
 * @interface IFieldTextProps
 * @author m.mayorov
 */
export const FieldText = ({
  addonAfter,
  addonBefore,
  className,
  controlRef,
  disabled,
  errorMessage,
  hasClear,
  hasError,
  hasIndependentLabel,
  helperText,
  innerRef,
  label,
  maxCharactersCounter,
  multiline,
  onBlur: _onBlur,
  onChange,
  onFocus: _onFocus,
  placeholder,
  renderControl,
  required,
  rowsMax = 20,
  rowsMin = 2,
  style,
  type,
  value = '',
  componentSize = 'l',
  ...props
}) => {
  const inputRef = React.useRef(null);
  const id = useUniqId('field-text-');
  const {
    width: inputWidth
  } = useResizeObserver({
    ref: inputRef,
    debounceDelay: 200
  });
  const {
    hasFocus,
    onFocus,
    onBlur
  } = useInputText({
    onFocus: _onFocus,
    onBlur: _onBlur
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, (hasIndependentLabel || maxCharactersCounter) && /*#__PURE__*/React.createElement("div", {
    className: styles.Header
  }, hasIndependentLabel && label && /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: styles.Label
  }, label, required && /*#__PURE__*/React.createElement("sup", null, "*")), maxCharactersCounter && /*#__PURE__*/React.createElement("div", {
    className: styles.Counter
  }, value.length, "/", maxCharactersCounter)), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Root, className, {
      [styles.HasIndependentLabel]: hasIndependentLabel
    }, {
      [styles.HasError]: hasError || errorMessage
    }, {
      [styles.IsDisabled]: disabled
    }, {
      [styles.IsLabelStuck]: addonBefore
    }, {
      [styles.HasFocus]: hasFocus
    }, {
      [styles.isMultiLine]: multiline
    }, {
      [styles.HasValue]: value.length > 0
    }, styles[componentSize + 'Size']),
    style: style,
    ref: innerRef
  }, !hasIndependentLabel && errorMessage ? /*#__PURE__*/React.createElement("div", {
    className: styles.Error
    //@ts-ignore
    ,
    style: {
      '--field-text-label-width': inputWidth + 'px'
    }
  }, errorMessage) :
  /**
     если есть placeholder,
     то label не показываем
     */
  !hasIndependentLabel && !placeholder && label && /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: styles.Label
    //@ts-ignore
    ,
    style: {
      '--field-text-label-width': inputWidth + 'px'
    }
  }, label, required && /*#__PURE__*/React.createElement("sup", null, "*")), /*#__PURE__*/React.createElement(InputText, _extends({
    addonAfter: addonAfter,
    addonBefore: addonBefore,
    controlRef: controlRef || inputRef,
    disabled: disabled,
    hasClear: hasClear,
    hasError: hasError,
    id: id,
    multiline: multiline,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    renderControl: renderControl,
    rowsMax: rowsMax,
    rowsMin: rowsMin,
    type: type,
    value: value,
    componentSize: componentSize
  }, props))), hasIndependentLabel && errorMessage && /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Error, styles.ErrorIsStatic)
  }, errorMessage), helperText && /*#__PURE__*/React.createElement("div", {
    className: styles.HelperText
  }, helperText));
};
if (process.env.NODE_ENV !== 'production') {
  FieldText.displayName = 'FieldText';
}